// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats__debt_header_container {
  display: inline-flex;
  gap: 20px;
  position: relative;
}
.stats__debt_header_container .stats__debt_header_button_container {
  flex: 1 1;
  width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/components/Statistic/StatsDebtorsHeader/StatsDebtorsHeader.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,SAAA;EACA,kBAAA;AACJ;AAAI;EACI,SAAA;EACA,YAAA;AAER","sourcesContent":[".stats__debt_header_container {\r\n    display: inline-flex;\r\n    gap: 20px;\r\n    position: relative;\r\n    .stats__debt_header_button_container {\r\n        flex: 1;\r\n        width: 200px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
